import React, { useEffect, useState } from 'react';
import GraphQuantOccurrence from './Grafico';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  FormControl,
  InputLabel,
  Select,
  Divider,
  MenuItem
} from '@mui/material';
import ReactTooltip from 'react-tooltip';
import HelpIcon from '@mui/icons-material/Help';
import { differenceInDays } from 'date-fns';

const classes = {
  root: {
    height: 310,
    paddingTop: 5,
    backgroundColor: "#fff"
  },
  formControl: {
    margin: 1,
    minWidth: 200
  }
};

export default function Grafico({ occurrences, startDate, endDate }) {
  const [optionToShowGraph, setOptionToShowGraph] = useState('month');

  const difference = differenceInDays(endDate, startDate);

  useEffect(() => {
    if (difference < 31) {
      setOptionToShowGraph('day');

    } else if (difference <= 56) {
      setOptionToShowGraph('week');

    } else {
      setOptionToShowGraph('month');

    }
  }, [startDate, endDate]);

  const cardHeader = (
    <>
      <FormControl variant="outlined" style={classes.formControl}>
        <InputLabel>Modo de visualização:</InputLabel>
        <Select
          value={optionToShowGraph}
          onChange={(e) => { setOptionToShowGraph(e.target.value); }}
          label="Estado dos itens exibidos: "
          style={{ 'background': '#fff' }}
        >
          {difference <= 31 ? <MenuItem value="day">Dia</MenuItem> : false}
          {difference <= 56 ? <MenuItem value="week" >Semana</MenuItem> : false}

          <MenuItem value="month">Mês</MenuItem>
        </Select>
      </FormControl>
    </>
  );

  const titleHeader = (
    <>
      <Typography
        className="box-title"
        gutterBottom
        variant="h6"
      >
        Ocorrências Abertas X Atendidas
        <HelpIcon style={{ 'color': '#a1a5ab' }} fontSize="small" data-for="graph-info" data-tip='Ocorrências Abertas são as ocorrências "Novas" e "Em análise". Ocorrências Atendidas são as ocorrências "Resolvidas" e "Indeferidas".' />
        <ReactTooltip id="graph-info" className='popup' />
      </Typography>

    </>
  );

  return (
    <>
      <Card>
        <CardHeader
          action={cardHeader}
          title={titleHeader}
        />

        <Divider />
        <CardContent style={classes.root}>
          <Box
            sx={{
              height: 310,
              position: 'relative'
            }}
          >
            <GraphQuantOccurrence
              occurrences={occurrences}
              optionToShowGraph={optionToShowGraph}
              endDate={endDate}
              startDate={startDate}
            />

          </Box>
        </CardContent>
      </Card>
    </>
  );
}